
import notification from './notification';
import constantsValid from './constantsValid';
import errorMesseage from './errorMesseage';

const manageNews = {notification, constantsValid, errorMesseage};

export default manageNews;